<div class="card" style="padding: 24px 36px 32px;">
  <div class="d-flex justify-content-end align-items-center gap-16">
    <app-titan-button 
        *ngIf="primaryButtonFunction" 
        [variant]="'primary'" 
        (onPress)="onPrimaryButtonClick()" 
        [isDisabled]="isExecutingAction">
      <ng-container children>
        <div>{{ currentPrimaryButtonText }}</div>
      </ng-container>
    </app-titan-button>
    <div style="width: 40px;" *ngIf="!primaryButtonFunction"></div>
    <i 
        style="cursor: pointer;"
        (click)="dialogRef.close()"
        aria-label="Close modal">
        <img src="assets/images/icons/titan/titan-close.svg" alt="Close" width="16" height="16">
    </i>
  </div>
  <div class="d-flex align-self-center">
    <mat-icon *ngIf="icon" [svgIcon]="icon" style="height: 36px; width: 36px"></mat-icon>
    <img *ngIf="image" [ngSrc]="image" alt="" height="200" style="background-color: transparent;" width="201">
  </div>
  <div class="d-flex flex-column" style="gap:32px">
    <div id="ai-report-summary-content" class="d-flex flex-column align-items-center" style="gap: 16px">
      <h5>{{ title }}</h5>
      <div  [innerHTML]="textContent" style="text-align:center; white-space: pre-line"></div>
    </div>
    <div class="d-flex justify-content-center gap-16">
      <app-titan-button [variant]="'secondary'" (onPress)="dialogRef.close()">
        <ng-container children>
          <div>{{ buttonText }}</div>
        </ng-container>
      </app-titan-button>
    </div>
  </div>
</div>
